var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { disabled: _vm.disabled, title: _vm.title } },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Icon Badge Expires", "hide-details": "" },
                model: {
                  value: _vm.model.iconBadgeExpires,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "iconBadgeExpires", _vm._n($$v))
                  },
                  expression: "model.iconBadgeExpires",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Icon Tooltip Reset", "hide-details": "" },
                model: {
                  value: _vm.model.iconTooltipReset,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "iconTooltipReset", _vm._n($$v))
                  },
                  expression: "model.iconTooltipReset",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }